import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const formTemplateImporterSelectors = importerSelectors(
  'formTemplate.importer',
);

export default formTemplateImporterSelectors;
